import classNames from 'classnames'
import React from 'react'
import injectStyles from 'react-jss'
import PenIcon from '../../../Assets/Images/icons/PenIcon'
import {
  STATUS_DOCUMENT_APPROVED,
  STATUS_DOCUMENT_MANUALY_APPLOADED,
  STATUS_DOCUMENT_REJECTED,
  STATUS_DOCUMENT_PENDING,
} from '../../../shared/constants'
import styles from './styles'

const ActionBlock = ({
  document,
  onDocumentStatusChange,
  onReject,
  onEdit,
  onSave,
  classes,
}) => {
  const renderStatusButtons = () => {
    if (document.status == STATUS_DOCUMENT_MANUALY_APPLOADED) {
      return (
        <div
          className={classNames({
            [classes.acceptedButtonIfDocAccepted]: true,
            [classes.button]: true,
            [classes.acceptButton]: true,
          })}
          cypress_id={'docStatus'}
        >
          Manually uploaded
        </div>
      )
    }
    if (document.status == STATUS_DOCUMENT_APPROVED) {
      return (
        <div
          className={classNames({
            [classes.button]: true,
            [classes.acceptButton]: true,
          })}
          cypress_id={'docStatus'}
        >
          Accepted
        </div>
      )
    }
    if (document.status == STATUS_DOCUMENT_REJECTED) {
      return (
        <div
          className={classNames({
            [classes.button]: true,
            [classes.rejectButton]: true,
          })}
          cypress_id={'docStatus'}
        >
          Rejected
        </div>
      )
    }
  }

  return (
    <div className={classes.container}>
      {document.isEdit ? (
        <div
          className={classes.saveButton}
          onClick={async () => await onSave(document)}
        >
          Save
        </div>
      ) : (
        <div
          className={classes.editButton}
          onClick={async () => await onEdit(document)}
          cypress_id={'editIcon'}
        >
          <PenIcon />
        </div>
      )}
      {document.status == STATUS_DOCUMENT_PENDING ? (
        <div className={classes.statusButtonsContainer}>
          <div
            onClick={async () =>
              await onDocumentStatusChange({
                document,
                status: STATUS_DOCUMENT_APPROVED,
              })
            }
            className={classNames({
              [classes.buttonContainer]: true,
              [classes.acceptWithHover]: true,
              [classes.button]: true,
            })}
            cypress_id={'actionsBtn'}
          >
            {'Accept'}
          </div>
          <div
            onClick={onReject}
            className={classNames({
              [classes.buttonContainer]: true,
              [classes.rejectWithHover]: true,
              [classes.button]: true,
            })}
            cypress_id={'actionsBtn'}
          >
            {'Reject'}
          </div>
        </div>
      ) : (
        renderStatusButtons()
      )}
    </div>
  )
}

export default injectStyles(styles)(ActionBlock)
